
























































































import {Vue, Component, Emit, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";
import axios from "axios";

@Component({
    components: {
    }
})

export default class PlanContentGenerator extends Vue {
    name= "PlanContentGenerator";

    loading = false;
    currentOptimizedPlan: any = null;

    // map getters
    @Getter base_url !: any;
    @Getter auth_header !: any;

    @Prop() experimentalPlanId !:number ;

    loadExperimentalPlanData(){
        this.setLoading(true);
        axios
            .get(
                this.base_url+ 'experiments/plans/'+this.experimentalPlanId+'/experiment_plan',
                {
                    headers: this.auth_header
                }
            )
            .then(response => {
                this.setLoading(false);
                console.log("Optimised experiment plan data",response.data);
                this.currentOptimizedPlan = response.data;
                this.waitRender(this.emitPlanHtml);

            })
            .catch(error => {
                this.setLoading(false);
                console.log("Something went wrong getting the Experimental Plan data :(", error);
            });
    }

    reload(){
        if(this.currentOptimizedPlan){
            this.setLoading(true);
            this.setLoading(false);
            this.waitRender(this.emitPlanHtml);

        } else {
            this.loadExperimentalPlanData();
        }
    }

    @Emit('loadingState')
    emitLoadingState() {
        return this.loading
    }

    mounted () {
        this.setLoading(false);
        this.loadExperimentalPlanData()
    }

    private setLoading(value: boolean) {
        this.loading = value;
        this.emitLoadingState();
    }

    private waitRender(callback: ()=> void) {
        setTimeout(()=>{
            callback();
        },10);
    }

    @Emit('planHtml')
    private emitPlanHtml() {
        let html = (this.$refs.content as Element).innerHTML;
        return html;
    }
}
